import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pos-session-detail',
  templateUrl: './pos-session-detail.component.html',
  styleUrls: ['./pos-session-detail.component.css']
})
export class PosSessionDetailComponent implements OnInit {

  private dp = [];
  no = '';
  open_cashier = '';
  open_cashier_en = '';
  close_cashier = '';
  close_cashier_en = '';

  displayedColumns = ['type', 'open', 'close_sys', 'close_actual', 'difference'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  Success_Msg; Error_Msg; Cash; Bank; Coupons; Total;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants, private router: Router,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService, private route: ActivatedRoute) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Cash').subscribe((res: string) => {
      this.Cash = res;
    });

    translate.get('Bank').subscribe((res: string) => {
      this.Bank = res;
    });

    translate.get('Coupons').subscribe((res: string) => {
      this.Coupons = res;
    });

    translate.get('Total').subscribe((res: string) => {
      this.Total = res;
    });

  }

  ngOnInit() {
    if (this.applicationConstants.user_info['role'] == 'casher')
      this.displayedColumns = ['type', 'open', 'close_actual'];

    this.route.params.subscribe(params => {
      this.no = params['no'];

      let query = "SELECT `pos_session`.*, `sub_acct`.`sub_acct_name`, `sub_acct`.`sub_acct_name_en`" + 
        " FROM `pos_session`, `sub_acct` WHERE `pos_session`.`status` = '1' AND `pos_session`.`session_no` = '" + 
        this.no + "' AND `pos_session`.`cashier` = `sub_acct`.`acct_number`";

      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let result = data.data['list'];
          this.open_cashier = result['0']['sub_acct_name'];
          this.open_cashier_en = result['0']['sub_acct_name_en'];

          console.log(result['0']['cashier_close']);
          // console.log(result);

          // this.open_cashier = result['0']['cashier'];
          // this.close_cashier = result['0']['cashier_close'];

          let open_total = (Number(result['0']['cash_open']) + Number(result['0']['bank_open']) +
            Number(result['0']['coupon_open'])).toFixed(2);

          let close_sys_total = '';
          if (result['0']['cash_close_sys'] != null) {
            close_sys_total = (Number(result['0']['cash_close_sys']) + Number(result['0']['bank_close_sys']) +
              Number(result['0']['coupon_close_sys'])).toFixed(2);
          }

          let close_actual_total = '';
          if (result['0']['cash_close_sys'] != null) {
            close_actual_total = (Number(result['0']['cash_close_actual']) + Number(result['0']['bank_close_actual']) +
              Number(result['0']['coupon_close_actual'])).toFixed(2);
          }

          this.dp = [{
              'id': 'cash', 'type': this.Cash, 'open': result['0']['cash_open'],
              'close_sys': result['0']['cash_close_sys'], 'close_actual': result['0']['cash_close_actual'],
              'difference': (result['0']['cash_close_sys'] == null) ? '' :
                (Number(result['0']['cash_close_sys']) - Number(result['0']['cash_close_actual'])).toFixed(2)
            },
            {
              'id': 'bank', 'type': this.Bank, 'open': result['0']['bank_open'],
              'close_sys': result['0']['bank_close_sys'], 'close_actual': result['0']['bank_close_actual'],
              'difference': (result['0']['bank_close_sys'] == null) ? '' :
                (Number(result['0']['bank_close_sys']) - Number(result['0']['bank_close_actual'])).toFixed(2)
            },
            {
              'id': 'coupon', 'type': this.Coupons, 'open': result['0']['coupon_open'],
              'close_sys': result['0']['coupon_close_sys'], 'close_actual': result['0']['coupon_close_actual'],
              'difference': (result['0']['coupon_close_sys'] == null) ? '' :
                (Number(result['0']['coupon_close_sys']) - Number(result['0']['coupon_close_actual'])).toFixed(2)
            },
            {
              'id': 'total', 'type': this.Total, 'open': open_total,
              'close_sys': close_sys_total, 'close_actual': close_actual_total,
              'difference': (close_sys_total == '') ? '' :
                (Number(close_sys_total) - Number(close_actual_total)).toFixed(2)
            }];

          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;

          // let query = "SELECT `employee`.`name` FROM `employee`, `user` WHERE `employee`.`status` = '1' AND `user`.`acct_number` = '"
          //   + result['0']['cashier'] + "' AND `user`.`employee_no` = `employee`.`employee_no`";
          // let obj = { cmd: 'getList', query: query };

          // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          //   .subscribe(data => {
          //     this.applicationConstants.appComp.hideBusyCursor();
          //     this.open_cashier = data.data['list'][0]['name'];
          //   });

          if (result['0']['cashier_close'] != 'NULL') {

            query = "SELECT `sub_acct`.`sub_acct_name`, `sub_acct`.`sub_acct_name_en` FROM `sub_acct` WHERE `sub_acct`.`acct_number` = '"
              + result['0']['cashier_close'] + "'";
            obj = { cmd: 'getList', query: query };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();
                
                if (data.data['list'].length != 0) {
                  this.close_cashier = data.data['list'][0]['sub_acct_name'];
                  this.close_cashier = data.data['list'][0]['sub_acct_name_en'];
                }
              });
          }
          
        });
    });
  }

}
